import { useEffect, useState } from 'react'
import Feature from "@arcgis/core/widgets/Feature.js";
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import { layerViewHighlight, observerAddToHandles, highLighthandles } from "../../../handles/Handles";
import Graphic from "@arcgis/core/Graphic";
import { getFieldsListFromString, updateIndex } from './FeatureWidgetVM';

const useFeatureHook = ({view,featureWidgetDiv,openPage}) => {
    const [featureCount,setFeatureCount]=useState(0)
    const [selectedFeatureIndex,setSelectedFeatureIndex]=useState<number>(0)
    const [selectedFeatureType,setSelectedFeatureType]=useState("")
    const[featuresArray,setFeaturesArray]=useState<any[]>([])
    // const[prevFeaturesArray,setPrevFeaturesArray]=useState<any[]>([])
    const[menuOptions,setMenuOptions]=useState({})
    const [openLayerDict, setOpenLayerDict] = useState({});

    // useEffect(()=>{
    //   if(view.popup.features.length){
    //     updateIndex(-view.popup.features.length, 1, view)
    //     //view.popup.selectedFeature=prevFeaturesArray[0]
    //     setSelectedFeatureIndex(1)
    //   }else{
    //     //setSelectedFeatureIndex(0)
    //   }
    // },[prevFeaturesArray])

    useEffect(()=>{
      let featuresList:any[]=[...featuresArray] as any[]
      const openLayersObject={...openLayerDict}
      const layerDict={}
      featuresList.forEach((feature,index)=>{
        if(feature.popupTemplate){
          if(feature?.parentLayerTitle){
            if(!layerDict[feature.parentLayerTitle]){
              layerDict[feature.parentLayerTitle]={layerName:feature.parentLayerTitle,list:[]}
              layerDict[feature.parentLayerTitle].list.push( {fieldList:getFieldsListFromString(feature.popupTemplate.title),index:index});
              openLayersObject[feature.parentLayerTitle]=false
            }
          }
          if(!layerDict[feature.layer?.title] && !feature?.parentLayerTitle){
            layerDict[feature.layer.title]={layerName:feature.layer.title,list:[]}
            layerDict[feature.layer.title].list.push( {fieldList:getFieldsListFromString(feature.popupTemplate.title),index:index});
            openLayersObject[feature.layer.title]=false

          }
  
        }else{
          if(!layerDict[feature.sourceLayer.title]){
            layerDict[feature.sourceLayer.title]={layerName:feature.sourceLayer.title,list:[]}
            openLayersObject[feature.sourceLayer.title]=false

          }
          layerDict[feature.sourceLayer.title].list.push({fieldList:getFieldsListFromString(feature.sourceLayer.popupTemplate.title),index:index});
        }
  
      });
      setOpenLayerDict(openLayersObject)
      setMenuOptions(layerDict);
  
    },[featuresArray])

    useEffect(()=> {
        if(view && featureWidgetDiv.current){
          //view.when(map=>{
            const graphic = new Graphic({
                popupTemplate: {
                  content: "Please identify a feature to view feature attributes"
                }
              });
            const featWidget = new Feature({
                container: featureWidgetDiv.current,
                view: view,
                map:view.map,
                graphic:graphic,
                spatialReference:view.spatialReference
            }) 
            observerAddToHandles(
                reactiveUtils.watch(
                  () => [view.popup.selectedFeature],
                  (array) => {
                    const [selectedFeature]=array
                    if(selectedFeature!==null){
                      if(selectedFeature?.layer?.type==="feature" || selectedFeature?.layer?.type==="graphics"){
                        setSelectedFeatureType(selectedFeature?.layer?.type)
                        setSelectedFeatureIndex(view.popup.selectedFeatureIndex+1)
                      view.popup.visible=false
                      let layerList= view.allLayerViews.filter(layerView=>{
                        return layerView.layer.id===selectedFeature.layer.id
                      })
                      if(layerList.length>0){
                        let lyrView=layerList.getItemAt(0)
                        layerViewHighlight(lyrView,[selectedFeature],"selectedFeatureWidget")
                      }
                        featWidget.graphic = selectedFeature
                        if(openPage.page !==openPage.compareVariable){
                          openPage.callback(openPage.compareVariable)
                        }
                        openPage.setHideDrawer(true)
 
                      }
                    }else{
                      featWidget.graphic = graphic
                      highLighthandles.removeAll()
                    }
                  }
                ),
                "featureWidget"
              );

              observerAddToHandles(reactiveUtils.watch(
                () => view.popup.featureCount,
                (featureCount) => {
                  setFeatureCount(featureCount)
                }
              ),
              "featureWidget-featureCount")
              
              observerAddToHandles(reactiveUtils.watch(
                () => view.popup.features,
                (features) => {
                  setFeaturesArray((prevFeatures)=>{
                    // if(prevFeatures.length){
                    // setPrevFeaturesArray(prevFeatures)
                    // }
                    return features
                  })
                }
              ),
              "featureWidget-featureArray")
            return ()=> {
                featWidget.destroy()
            }
        //})
      }
    },[view])

  return {featureCount,selectedFeatureIndex,selectedFeatureType/*,prevFeaturesArray*/,featuresArray,menuOptions,openLayerDict,setOpenLayerDict} as const
}

export default useFeatureHook